import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import SqlMiCalc from '../components/calculators/SqlMiCalc'
import { Breadcrumbs } from '../components/shared/Breadcrumbs'
import { generateBreadcrumbList } from '../utils/schemaHelpers'

export default function SqlMiCalculatorPage() {
  return (
    <>
      <Helmet>
        <title>Azure SQL Managed Instance Cost Calculator UK | AzureCalc.uk</title>
        <meta name="description" content="Estimate Azure SQL Managed Instance costs in GBP for UK South. General Purpose vs Business Critical, AHB, Reserved Instances, and storage pricing." />
        <link rel="canonical" href="https://www.azure-calc.co.uk/sql-managed-instance" />
        <meta property="og:title" content="Azure SQL Managed Instance Cost Calculator UK" />
        <meta property="og:description" content="SQL MI pricing in GBP for UK South — model GP vs BC tiers, Azure Hybrid Benefit, Reserved Instances, and storage to surface the true monthly cost." />
        <meta property="og:url" content="https://www.azure-calc.co.uk/sql-managed-instance" />
        <meta property="og:image" content="https://www.azure-calc.co.uk/og/azure-calc-og.png" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">{JSON.stringify(generateBreadcrumbList([
          { name: 'Home', url: '/', position: 1 },
          { name: 'Azure SQL Managed Instance Calculator', url: '/sql-managed-instance', position: 2 },
        ]))}</script>
        <script type="application/ld+json">{JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebApplication',
          name: 'Azure SQL Managed Instance Cost Calculator',
          description: 'Independent SQL Managed Instance pricing calculator for UK South — model GP vs BC tiers, AHB, Reserved Instances, and storage in GBP.',
          url: 'https://www.azure-calc.co.uk/sql-managed-instance',
          applicationCategory: 'FinanceApplication',
          operatingSystem: 'Web',
          offers: { '@type': 'Offer', price: '0', priceCurrency: 'GBP' },
        })}</script>
      </Helmet>

      <div className="px-6 py-6 w-full">
        <div className="pb-6 mb-8" style={{ borderBottom: '1px solid var(--outline-variant)' }}>
          <Breadcrumbs />
          <h1 className="text-2xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
            Azure SQL Managed Instance Cost Calculator
          </h1>
          <p className="text-sm" style={{ color: 'var(--text-tertiary)' }}>
            UK South pricing · General Purpose &amp; Business Critical · Azure Hybrid Benefit · Reserved Instances
          </p>
        </div>

        <SqlMiCalc />

        <div className="mt-12 pt-8" style={{ borderTop: '1px solid var(--outline-variant)' }}>
          <h2 className="text-[13px] font-bold uppercase tracking-widest mb-4" style={{ color: 'var(--text-tertiary)' }}>Related guides</h2>
          <div className="space-y-2">
            <Link
              to="/guides/azure-sql-managed-instance-pricing-uk"
              className="flex items-center gap-3 p-4 rounded transition-colors group"
              style={{ backgroundColor: 'var(--surface-container)', border: '1px solid var(--outline-variant)' }}
            >
              <span className="material-symbols-outlined text-[#0078d4] text-[20px]" style={{ fontVariationSettings: "'FILL' 1" }}>menu_book</span>
              <div>
                <p className="text-[14px] font-semibold group-hover:text-[#0078d4] transition-colors" style={{ color: 'var(--text-secondary)' }}>Azure SQL Managed Instance Pricing Guide UK</p>
                <p className="text-[12px]" style={{ color: 'var(--text-tertiary)' }}>AHB, Reserved Instances, tier selection, and migration cost planning</p>
              </div>
              <span className="material-symbols-outlined text-[#0078d4] text-[16px] ml-auto">arrow_forward</span>
            </Link>
            <Link
              to="/sql-database"
              className="flex items-center gap-3 p-4 rounded transition-colors group"
              style={{ backgroundColor: 'var(--surface-container)', border: '1px solid var(--outline-variant)' }}
            >
              <span className="material-symbols-outlined text-[#0078d4] text-[20px]" style={{ fontVariationSettings: "'FILL' 1" }}>database</span>
              <div>
                <p className="text-[14px] font-semibold group-hover:text-[#0078d4] transition-colors" style={{ color: 'var(--text-secondary)' }}>Azure SQL Database Calculator</p>
                <p className="text-[12px]" style={{ color: 'var(--text-tertiary)' }}>Compare DTU vs vCore, Serverless, and Hyperscale pricing</p>
              </div>
              <span className="material-symbols-outlined text-[#0078d4] text-[16px] ml-auto">arrow_forward</span>
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}
